import { useContext } from 'react';
import { AuthContext } from '../services/authContext';
import { Navigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import '../scss/components/reports.scss';

//Components

const Reports = () => {

    const { isLoggedIn, userProfile } = useContext(AuthContext);

    if (!isLoggedIn || !userProfile) {
        return <Navigate to="/" />;
    }
    return (
        <div id="Reports" className="screen">
            <Row>
                <Col xs={12} className="p-0">
                    <p className="text-center mt-3">Reports coming soon</p>
                </Col>
            </Row>
        </div>
    );
};

export default Reports;
